<template>
    <entity-list
        entity="rumour"
        :use-events="true"
        :entity-headers="headers"
        :events-values="rumourEvents"
        :event-id="eventId"
        :team-id="teamId"
    >
    </entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
import { mapGetters } from 'vuex'
export default {
    components: {
        'entity-list': EntityList,
    },
    props: {
        eventId: {
            type: [String, Number],
            required: false,
        },
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                    width: '50%',
                },
                { text: 'Rumour Type', value: 'rumourTypeText' },
                { text: 'Team', value: 'teamName', filterable: false },
                { text: 'Status', value: 'statusText', filterable: false },
            ],
        }
    },
    computed: {
        ...mapGetters(['events']),
        rumourEvents() {
            return this.events.filter(x => x.isRumourEvent)
        },
    },
}
</script>
